{
  "slug": "what-is-the-average-iq",
  "title": "औसत IQ क्या है?",
  "description": "देखें कि औसत IQ क्यों आमतौर पर. 100, कैसे मानक विचलन और प्रतिशत काम करते हैं, और कैसे जिम्मेदारी से तुलनाओं की व्याख्या करते हैं।",
  "summary": "अधिकांश आधुनिक आईक्यू पैमाने पर, औसत को सेट किया जाता है 100. संदर्भ जनसंख्या के लगभग दो तिहाई के बीच गिरते हैं. 85 और 115.",
  "sections": [
    {
      "heading": "औसत क्यों है? 100",
      "paragraphs": [
        "IQ स्केल सही उत्तरों की एक निश्चित संख्या पर आधारित होने के बजाय मानकीकृत हैं. प्रकाशक कच्चे परिणामों को बदलते हैं ताकि संदर्भ समूह में  का औसत हो 100. परीक्षणों को समय-समय पर पुनर्निर्धारित किया जाता है क्योंकि आबादी और शैक्षिक अनुभव बदलते हैं।",
        "स्कोर के पास 100 चयनित मानक समूह के मध्य के करीब प्रदर्शन का अर्थ है- नहीं कि किसी ने जवाब दिया 100 प्रश्न या एक निश्चित मात्रा में बुद्धि का स्वामी है."
      ]
    },
    {
      "heading": "सामान्य 85–115 सीमा",
      "paragraphs": [
        "के मानक विचलन के साथ 15, के बारे में 68सामान्य वितरण का% इस से मिलता जुलता है. 85 दो 115, और के बारे में 95% से 70 दो 130. ये अनुमान हैं.",
        "प्रतिशत को समझना आसान हो सकता है: 100 के पास है 50th percentile, 115 के पास 84थ, और 85 के पास 16ता॰ हू॰ मीम॰"
      ]
    },
    {
      "heading": "तुलनाओं का सावधानी से प्रयोग करें",
      "paragraphs": [
        "एक स्कोर को उपयुक्त आयु मानदंडों और एक वर्तमान परीक्षण संस्करण की आवश्यकता होती है. भाषा, शिक्षा, स्वास्थ्य और संदर्भ विषय. क्रॉस-देश या जनसांख्यिकीय तुलनाएं नमूनाकरण और विधि के लिए विशेष रूप से संवेदनशील होती हैं।",
        "एक व्यक्ति के लिए, एक विश्वसनीय अंतराल और उप-परीक्षा प्रोफ़ाइल, पूर्ण रूप से सटीक होने के रूप में कुल के रूप में व्यवहार करने से अधिक उपयोगी है।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "बर्फ 100 एक अच्छा आईक्यू स्कोर?",
      "answer": "एक स्कोर 100 यह समूह के केंद्र में है और क्षमताओं का मूल्यांकन करने पर विशिष्ट प्रदर्शन का प्रतिनिधित्व करता है।"
    },
    {
      "question": "ऊपर अंक प्राप्त करने वाले लोगों का प्रतिशत क्या है? 100?",
      "answer": "ऊपर लगभग आधे अंक 100 हालांकि, वास्तविक मानक वितरण पूरी तरह से सममित नहीं हैं।"
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "how-is-iq-measured"]
}
